// extracted by mini-css-extract-plugin
module.exports = {"totalAgentData":"TotalAgentData_totalAgentData___Df3g","formInline":"TotalAgentData_formInline__16APP","buttongroup":"TotalAgentData_buttongroup__2ifqM"};